/** localStorage key for the schedule team picker (consultant + partner_broker). */
export const SCHEDULE_SELECTED_TEAM_STORAGE_KEY = "@7Cantos:scheduleTeamId";
